import { Component, Input, OnInit } from '@angular/core';

import { Group } from '@libs/src/models/group.model';

@Component({
  selector: 'app-setup-redirect-banner',
  templateUrl: './setup-redirect-banner.component.html',
})
export class SetupRedirectBannerComponent implements OnInit {
  @Input() group: Group;
  routerLink: string[];

  ngOnInit(): void {
    this.routerLink = ['/hub', this.group.slug, 'manage-settings'];
  }
}
